import { Reducer } from 'redux';
import { ChatState, ChatActionTypes } from './type';

const initialState = {
  msgList: [],
  doctorInfo: {},
  assistantInfo: {},
  historyTime: 0,
  roomId: 0,
  receiveMsgRes: [],
  consultInfo: {},
  userHeadPortrait: '',
  consultDetail: {},
  thirdPatientInfoDomain: {
    illnessDescription: '',
    patientAge: '',
    patientGender: '',
    patientName: '',
    symptomDuration: '',
  },
};

const reducer: Reducer<ChatState> = (state = initialState, action) => {
  switch (action.type) {
  case ChatActionTypes.FETCH_CONSULT_INFO_SUCCESS: {
    return {
      ...state,
      ...action.data,
      doctorInfo: {
        ...state.doctorInfo,
        ...action.data.doctorInfo,
      },
    };
  }
  case ChatActionTypes.ADD_CHAT_MSG: {
    return {
      ...state,
      msgList: [
        ...state.msgList,
        ...action.data,
      ],
    };
  }
  case ChatActionTypes.SHIFT_CHAT_MSG: {
    return {
      ...state,
      msgList: [
        ...action.data,
        ...state.msgList,
      ],
    };
  }
  case ChatActionTypes.UPDATE_SOME_MSG: {
    const list = state.msgList;
    const msg = action.data;
    const newList = list.map((item) => {
      const { reply_content: { mode = '' } } = item;
      if ((item.msg_id && item.msg_id === msg.msg_id) || ((mode === 'realauth' || mode === 'mobile') && mode === msg.reply_content.mode)) {
        return {
          ...item,
          ...msg,
        };
      }
      return item;
    });
    return {
      ...state,
      msgList: newList,
    };
  }
  case ChatActionTypes.UPDATE_LAST_MSG_OR_ADD: {
    const list = state.msgList;
    const msg = action.data || {};
    const oldMsg = list.find((item) => item.msg_id && item.msg_id === msg.msg_id);

    if(!oldMsg) {
      return {
        ...state,
        msgList: [
          ...state.msgList,
          msg,
        ],
      };
    }
    const newList = list.map((item) => {
      const { reply_content: { mode = '' } } = item;
      if ((item.msg_id && item.msg_id === msg.msg_id) || ((mode === 'realauth' || mode === 'mobile') && mode === msg.reply_content.mode)) {
        item.reply_content.content += (msg.reply_content || {}).content || '';
        return {
          ...item,
        };
      }
      return item;
    });
    return {
      ...state,
      msgList: newList,
    };
  }
  case ChatActionTypes.EDIT_CHAT_INFO: {
    return {
      ...state,
      ...action.data,
    };
  }
  case ChatActionTypes.ADD_RECEIVE_MSG_RES: {
    return {
      ...state,
      receiveMsgRes: [...state.receiveMsgRes, action.data],
    };
  }
  case ChatActionTypes.RESET_CHAT_STATE: {
    return {
      ...state,
      msgList: [],
      historyTime: 0,
      roomId: 0,
      receiveMsgRes: [],
      consultInfo: {},
      userHeadPortrait: '',
    };
  }
  case ChatActionTypes.RESET_MSGLIST_STATE: {
    return {
      ...state,
      msgList: [],
      historyTime: new Date().getTime(),
    };
  }
  case ChatActionTypes.EDIT_LAST_MSG: {
    const msg = action.data || {};
    const lastMsg = state.msgList[state.msgList.length - 1];
    state.msgList.pop();
    const newMsg = {
      ...lastMsg,
      ...msg,
    };
    state.msgList.push(newMsg);
    return {
      ...state,
      msgList: [
        ...state.msgList,
      ],
    };
  }
  case ChatActionTypes.DELETE_LAST_MSG: {
    state.msgList.pop();
    console.log(state.msgList);
    return {
      ...state,
      msgList: [
        ...state.msgList,
      ],
    };
  }
  // 咨询单详情
  case ChatActionTypes.FETCH_CONSULT_DETAIL_SUCCESS: {
    return {
      ...state,
      consultDetail: action.data,
    };
  }

  default: {
    return state;
  }
  }
};

export { reducer as ChatReducer };
